export const checkDocumentIsAccessible = (ruleLocationIds: string[], documentLocationIds: string[]) => {
  return !!ruleLocationIds.every((locationId) => documentLocationIds && documentLocationIds.includes(locationId));
};
